import { HeroMinimal, QualificationForm } from "../components/sections";
import { CheckCircle, ArrowRight } from "lucide-react";

import { CALENDAR_URL } from "../config/site";

function BookPage() {
  return (
    <>
      <HeroMinimal
        title="Let's Build Your Outbound System."
        subtitle="Tell us about your company, target market, sales process, and growth goals. We'll identify where an outbound system could create the most leverage."
        ctaText=""
        ctaHref="#"
      />

      <section className="section" aria-labelledby="booking-title">
        <div className="container">
          <div className="max-w-6xl mx-auto">
            <div className="card-elevated p-5 md:p-10">
              <div className="booking-layout grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
                <div className="lg:sticky lg:top-24">
                  <span className="label text-accent mb-4 inline-block">
                    Strategy Call
                  </span>
                  <h2
                    id="booking-title"
                    className="h1 md:display-sm text-text-primary mb-4"
                  >
                    Book a Strategy Call
                  </h2>
                  <p className="body-lg text-text-secondary mb-8">
                    A 30-minute conversation to understand your business, assess
                    outbound readiness, and outline where a system could create
                    leverage. No pitch. No pressure.
                  </p>
                  <ul className="space-y-4 mb-8" role="list">
                    {[
                      "No generic templates; a system designed around your business",
                      "Technical assessment of your current setup",
                      "Clear next steps and architecture overview",
                      "No obligation to continue",
                    ].map((item, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-3 text-text-secondary"
                      >
                        <CheckCircle
                          size={20}
                          className="text-accent flex-shrink-0"
                          aria-hidden="true"
                        />
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="p-4 bg-surface rounded-lg border border-border">
                    <h3 className="label text-text-primary mb-2">
                      What Happens After Booking
                    </h3>
                    <ol
                      className="space-y-2 text-sm text-text-secondary"
                      role="list"
                    >
                      {[
                        "Receive calendar confirmation with video link",
                        "Confirm your contact details and goals in the calendar",
                        "Strategy call: assess fit & outline system",
                        "If fit: receive custom system proposal",
                      ].map((step, i) => (
                        <li key={i} className="flex items-center gap-2">
                          <span className="w-5 h-5 rounded-full bg-accent/10 flex items-center justify-center text-accent text-xs font-mono flex-shrink-0">
                            {i + 1}
                          </span>
                          {step}
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
                <div>
                  <QualificationForm calComUrl={CALENDAR_URL} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Alternative CTA */}
      <section
        className="section bg-surface border-y border-border"
        aria-labelledby="alternative-title"
      >
        <div className="container">
          <div className="max-w-2xl mx-auto text-center">
            <h2
              id="alternative-title"
              className="h1 md:display-sm text-text-primary mb-4"
            >
              Prefer to Start With a Conversation?
            </h2>
            <p className="body-lg text-text-secondary mb-8">
              Not ready for the full qualification? Schedule a brief intro call
              to ask questions and explore fit.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={CALENDAR_URL}
                className="btn btn-primary btn-lg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Schedule Intro Call
                <ArrowRight size={18} aria-hidden="true" />
              </a>
              <a
                href="mailto:hello@uniqreach.com"
                className="btn btn-secondary btn-lg"
              >
                Email Us Instead
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BookPage;
